import { General } from "./class/General";
import { SwiperOperate } from "./class/SwiperOperate";

window.addEventListener("DOMContentLoaded", () => {
  setLoading(); // ローディングアニメーション
  setSmallWindow(); // 小さいウィンドウサイズ対応
  setAnimation(); // アニメーションの登録

  const general = new General();
  general.setAnchorPosition(); // アンカーリンクの位置調整（ページロード時用）
  general.setSmoothScroll(); // スムーススクロール
  const so = new SwiperOperate(); // Swiper

  // 画面表示時に不要なものの動作停止（デバッグ用） ここから
  // const loadingArea = document.getElementById("loadingAnime");
  // if (loadingArea) {
  //   loadingArea.style.display = "none";
  // }
  // 画面表示時に不要なものの動作停止（デバッグ用） ここまで
});

// -------------------------------------
// 機能：ローディングアニメーションの登録
// -------------------------------------
function setLoading() {
  // ローディング画面
  const loadingArea = document.getElementById("loadingAnime"); // ローディング画面全体
  if (loadingArea) {
    const images = document.getElementsByTagName("img"); // ページ内のimgタグを取得
    const percentNumber = document.getElementById("loadingAnime_percentNum"); // ●%の●部分
    const loadingGauge = document.getElementById("loadingAnime_gaugeLine"); // リアルタイムで読み込まれるゲージ部分
    let imgCounting = 0;
    let baseCounting = 0;
    const gaugeWidth = 100; // ゲージの全体幅
    let current;

    // 画像の読み込み
    for (let i = 0; i < images.length; i++) {
      const img = new Image(); // 新たなimg要素を作成
      // 画像読み込み完了したとき
      img.onload = function () {
        imgCounting += 1;
      };
      // 画像読み込み失敗したとき
      img.onerror = function () {
        imgCounting += 1;
      };
      img.src = images[i].src; // ソースのパスを設定
    }
    // console.log(images.length);
    // setIntervalを使って一定時間ごとに処理を繰り返す
    const nowLoading = setInterval(function () {
      // baseCountingがimgCountingより大きくならない条件の場合に処理を実行させる。2回目以降にページを読み込んだ時に画像の読み込み履歴が残っている関係で、ローディング画面の表示が速く終わってしまうため、その対策として条件をつけている。
      if (baseCounting <= imgCounting) {
        baseCounting += 1;
        // リアルタイムで読み込んでいるパーセントを取得
        current = Math.floor((baseCounting / images.length) * 100);
        // ●%の●部分に数字を置き換える
        if (percentNumber) {
          percentNumber.innerHTML = current.toString();
        }
        // リアルタイムで読み込まれるゲージ部分を反映させる
        if (loadingGauge) {
          loadingGauge.style.width =
            Math.floor((gaugeWidth / 100) * current) + "%";
        }
      }
      // 全て読み込んだ時
      if (baseCounting === imgCounting) {
        clearInterval(nowLoading);
        if (percentNumber) {
          percentNumber.innerHTML = "100";
        }
        if (loadingGauge) {
          loadingGauge.style.width = "100%";
        }
        setTimeout(function () {
          loadingArea.style.opacity = "0";
          setTimeout(function () {
            loadingArea.style.display = "none";
          }, 300); // フェードアウトのための遅延
        }, 500); // 少しの遅延を加える
      }
    }, 50);
  }
}

// -------------------------------------
// 機能：小さい画面の場合は、360pxの画面を縮小したものにする
// -------------------------------------
function setSmallWindow() {
  const viewport = document.querySelector('meta[name="viewport"]');
  function switchViewport() {
    if (viewport) {
      const value =
        window.outerWidth > 374
          ? "width=device-width,initial-scale=1"
          : "width=375";
      if (viewport.getAttribute("content") !== value) {
        viewport.setAttribute("content", value);
      }
    }
  }
  addEventListener("resize", switchViewport, false);
  switchViewport();
}

// -------------------------------------
// 機能：アニメーションの登録
// -------------------------------------
function setAnimation() {
  const scrollIns = document.querySelectorAll(".scrollIn");

  const options = {
    root: null, // 今回はビューポートをルート要素とする
    rootMargin: "0px 0px -20% 0px", // ビューポートの中心を判定基準にする
    threshold: 0,
  };
  const observer = new IntersectionObserver(callback, options);
  if (scrollIns) {
    scrollIns.forEach(function (box) {
      observer.observe(box);
    });
  }

  function callback(entries: any) {
    entries.forEach(function (entry: any, i: number) {
      const target = entry.target;
      if (entry.isIntersecting && !target.classList.contains(".active")) {
        const delay = i * 50;
        setTimeout(function () {
          target.classList.add("active");
        }, delay);
      }
    });
  }
}
